<template>
    <div class="login-container bg-info h-100">
        <div class="row no-gutters h-100">
            <div class="col-lg-4 h-100 bg-success shadow" style="z-index: 9;">
                <div class="login-splash h-100 w-100">
                    <div class="login-splash-image h-100 w-100"></div>
                </div>
            </div>
            <div class="col-lg-8 h-100 bg-white">
                <div class="d-flex flex-column justify-content-center align-items-center h-100 w-100">
                    <login-panel></login-panel>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import LoginPanel from '../components/login/login-panel'

export default {
    components: {
        LoginPanel
    }
}
</script>
<style lang="scss" scoped>
@import '../styles/bootstrap/_custom';

.login-container {
    display: flex;
    flex-direction: column;
    margin: 0;
}

.login-splash {
    background-image: linear-gradient(135deg, $primary 0, $success 100%);
}

.login-splash-image {
    opacity: 0.4;
    background-size: cover;
    background-image: url('../assets/login_splash.jpg');
}

</style>


// WEBPACK FOOTER //
// src/views/login-page.vue